import React from 'react';
import colorVariables from '@densityco/ui/variables/colors.json';

const MPI_THRESHOLD = 50;
const REGULAR_THRESHOLD = 175;

const ColoredQaedEventCount: React.FunctionComponent<{value: number, isMPI: boolean}> = ({value, isMPI}) => {
  const threshold = isMPI ? MPI_THRESHOLD : REGULAR_THRESHOLD;
  return (
    <span style={value < threshold ? { color: colorVariables.red } : {}}>
      {value}
    </span>
  );
};

export default ColoredQaedEventCount;
